import { Injectable } from '@angular/core';
import { IntegrationsHandlerService } from "../handlers/integrations-handler.service";
import { EmailProviderHandlerService } from "../handlers/email-provider-handler.service";
import { IntegrationProvidersHandlerService } from "../handlers/integration-providers-handler.service";
import { IntegrationDTO } from './Integration';

@Injectable({
  providedIn: 'root'
})
export class IntegrationsService {

  constructor(
    private IntegrationProvidersHandlerService: IntegrationProvidersHandlerService,
    private IntegrationsHandlerService: IntegrationsHandlerService,
    private EmailProviderHandlerService: EmailProviderHandlerService,
  ) { }

  getIntegrationProviders(masterAccountID: number) {
    return this.IntegrationProvidersHandlerService.getIntegrationProviders(
      masterAccountID,
    );
  }
  
  getIntegrations(masterAccountID?: number, appID?: number, paginated: boolean = false, type?: string) {
    return this.IntegrationsHandlerService.getIntegrations(
      masterAccountID,
      appID,
      {
        "type": type ? type : "null",
        "paginated": paginated
      }
    );
  }

  getIntegration(masterAccountID: number, integrationID: number, appID?: number,) {
    return this.IntegrationsHandlerService.getIntegration(masterAccountID, integrationID, appID);
  }

  getEmailTemplates(provider: string, integrationID: number) {
    return this.EmailProviderHandlerService.getTemplates(provider, integrationID);
  }

  deleteIntegration(accountMasterID: number, integrationID: number) {
    return this.IntegrationsHandlerService.deleteIntegration(
      accountMasterID,
      integrationID,
    );
  }

  createIntegration(accountMasterID: number, integrationDTO: IntegrationDTO) {
    return this.IntegrationsHandlerService.postIntegration(
      accountMasterID,
      integrationDTO,
    );
  }

  updateIntegration(accountMasterID: number, integrationDTO: IntegrationDTO) {
    return this.IntegrationsHandlerService.putIntegration(
      accountMasterID,
      integrationDTO,
    );
  }

  getIntegrationUsageReport(masterAccountID: number, integrationID: string, queryParams: {
    start_date: string;
    end_date: string;
    include_tests?: boolean;
  }) {
    return this.IntegrationsHandlerService.getIntegrationUsageReport(
      masterAccountID,
      integrationID,
      queryParams,
    );
  }

  getThreadFeedbackList(masterAccountID: number, integrationID: number, queryParams: {
    start_date: string;
    end_date: string;
    page?: number;
    perPage?: number;
    include_tests?: boolean;
  }) {
    return this.IntegrationsHandlerService.getThreadFeedbackList(
      masterAccountID,
      integrationID,
      queryParams,
    );
  }

  getThreadList(masterAccountID: number, integrationID: number, queryParams: {
    start_date: string;
    end_date: string;
    page?: number;
    perPage?: number;
    include_tests?: boolean;
  }) {
    return this.IntegrationsHandlerService.getThreadList(
      masterAccountID,
      integrationID,
      queryParams,
    );
  }

  exportThreadListPdf(masterAccountID: number, integrationID: number, queryParams: {
    start_date: string;
    end_date: string;
    include_tests?: boolean;
  }) {
    return this.IntegrationsHandlerService.exportThreadListPdf(
      masterAccountID,
      integrationID,
      queryParams,
    );
  }

  getThreadDetail(masterAccountID: number, integrationID: number, threadID: number) {
    return this.IntegrationsHandlerService.getThreadDetail(
      masterAccountID,
      integrationID,
      threadID,
    );
  }

  generateSecret(masterAccountID: number, integrationID: number) {
    return this.IntegrationsHandlerService.generateSecret(
      masterAccountID,
      integrationID,
    );
  }

  computeIdentityHash(masterAccountID: number, integrationID: number, externalUserId: string) {
    return this.IntegrationsHandlerService.computeIdentityHash(
      masterAccountID,
      integrationID,
      externalUserId,
    );
  }
}
